import { memo } from 'react'

interface FormActionsProps {
  children: React.ReactNode
  className?: string
}

export const FormActions = memo(({ children, className }: FormActionsProps) => {
  const classes = ['form-actions', className ?? ''].filter(Boolean).join(' ')
  return <div className={classes}>{children}</div>
})

FormActions.displayName = 'FormActions'
